// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invSterilizationPresetId } from './InvSterilizationPreset';
import { invResourceId } from './InvResource';
import { z } from 'zod';
export const invSterilizationPresetAdditiveId = (z.number());
export const invSterilizationPresetAdditive = z.object({
    id: invSterilizationPresetAdditiveId,
    preset_id: invSterilizationPresetId,
    resource_id: invResourceId,
    ml_per_kg: z.string(),
    display_order: z.number(),
});
export const invSterilizationPresetAdditiveInitializer = z.object({
    id: invSterilizationPresetAdditiveId.optional(),
    preset_id: invSterilizationPresetId,
    resource_id: invResourceId,
    ml_per_kg: z.string(),
    display_order: z.number().optional(),
});
export const invSterilizationPresetAdditiveMutator = z.object({
    id: invSterilizationPresetAdditiveId.optional(),
    preset_id: invSterilizationPresetId.optional(),
    resource_id: invResourceId.optional(),
    ml_per_kg: z.string().optional(),
    display_order: z.number().optional(),
});
//# sourceMappingURL=InvSterilizationPresetAdditive.js.map